module.exports = __webpack_public_path__ + "static/media/sliders-v-alt.58ae132c.svg";